// removed by extract-text-webpack-plugin
module.exports = {"RoundSectionTeaser":"src-components-FourColumnsBlock----RoundSectionTeaser-module---RoundSectionTeaser---3YD9l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FourColumnsBlock/RoundSectionTeaser.module.css
// module id = 378
// module chunks = 35783957827783